// Module
var code = "<div> <fault :fault=\"bug\" :newfault=\"newfault\"></fault> </div>";
// Exports
module.exports = code;